export default "__VITE_ASSET__B0Ucq6vr__"